import { render, staticRenderFns } from "./ForgotPasswordValidation.vue?vue&type=template&id=72b7fcce"
import script from "./ForgotPasswordValidation.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordValidation.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordValidation.vue?vue&type=style&index=0&id=72b7fcce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports